import actionType from '../actionTypes/snackbarActionType';

/**
 * @param message
 * @param type string (success, error, warning, info, default)
 * @param persist If false, snackbar will be closed automatically after few seconds.
 */
const addSnackbar = (message: string, type: string, persist: boolean) => ({
    type: actionType.addSnackbar,
    notification: {
        key: new Date().getTime() + Math.random(),
        message,
        type: type || 'default',
        persist: persist || false,
    },
});

const removeSnackbar = (key: number) => ({
    type: actionType.removeSnackbar,
    key,
});

export { addSnackbar, removeSnackbar };
